<div nz-col class="container_host">
  <div nz-col>
    <div nz-row style="padding: 10px" nzJustify="space-between">
      <div nz-col nzFlex="auto">
        <form
          nz-form
          [nzLayout]="'inline'"
          [formGroup]="searchForm"
          (ngSubmit)="search()"
        >
          <beautyapp-input
            formControlName="search"
            placeholder="{{ 'users.search.searchWord' | translate }}"
            prefixIcon="search"
          ></beautyapp-input>
          <beautyapp-select
            placeholder="{{ 'users.search.branch' | translate }}"
            [data]="branches$ | async"
            displayMember="name"
            valueMember="id"
            formControlName="branch"
          >
          </beautyapp-select>
          <beautyapp-select
            placeholder="{{ 'users.search.userSource' | translate }}"
            [data]="userSources()"
            displayMember="name"
            valueMember="id"
            formControlName="userSourceId"
          >
          </beautyapp-select>
          <label nz-checkbox formControlName="withBalance">{{ 'users.search.withBalance' | translate }}</label>
          <label nz-checkbox formControlName="withMinutes">{{ 'users.search.withMinutes' | translate }}</label>
          <button
            nz-button
            nzType="primary"
            nzSize="small"
            nzShape="circle"
            [disabled]="!searchForm.valid"
          >
            <i nz-icon nzType="search" nzTheme="outline"></i>
          </button>
          @if (searchValue || branchId || searchForm.value.userSourceId) {
            <button
              nz-button
              nzType="link"
              type="button"
              (click)="clearSearch()"
            >
              <i nz-icon nzType="close-circle" nzTheme="outline"></i>
            </button>
          }
        </form>
      </div>
      <div nz-col nzFlex="initial">
        <ng-template [ngxPermissionsOnly]="['Admin', 'Manager']">
          <button
            nz-button
            nzType="primary"
            nzShape="circle"
            nz-tooltip
            nzTooltipTitle="{{ 'buttons.newRecord' | translate }}"
            (click)="addOrEdit()"
          >
            <i nz-icon nzType="plus"></i>
          </button>
        </ng-template>
        <ng-template [ngxPermissionsOnly]="['Admin', 'Manager']">
          <button
            nz-button
            nzType="default"
            nzShape="circle"
            nz-tooltip
            nzTooltipTitle="{{ 'buttons.massiveUpload' | translate }}"
            routerLink="/customers/upload"
          >
            <i nz-icon nzType="upload" nzTheme="outline"></i>
          </button>
        </ng-template>
        <button
          *ngxPermissionsOnly="['Admin', 'Manager']"
          nz-button
          nzType="default"
          nzShape="circle"
          nz-tooltip
          nzTooltipTitle="{{ 'buttons.download' | translate }}"
          (click)="export()"
        >
          <i nz-icon nzType="file-excel" nzTheme="outline"></i>
        </button>
      </div>
    </div>

    <div nz-col class="body-content">
      <!--      <pre>-->
      <!--      {{employees | json}}-->
      <!--      </pre>-->
      <nz-table
        nzBordered
        nzShowSizeChanger
        [nzData]="loadData"
        [nzFrontPagination]="false"
        [nzLoading]="loading"
        [nzTotal]="total"
        [nzPageSize]="paginatorPageSize"
        [nzPageIndex]="paginatorPageIndex"
        [nzVirtualForTrackBy]="trackByIndex"
        (nzQueryParams)="paginatorChange($event)"
        [nzPageSizeOptions]="[5, 10, 20, 50, 100]"
        nzTableLayout="auto"
        [nzScroll]="{ x: '100%' }"
        nzSize="small"
      >
        <thead>
        <tr>
          <th nzWidth="100px">{{ 'users.column.cardNo' | translate }}</th>
          <th nzLeft nzWidth="150px">{{ 'users.column.name' | translate }}</th>
          <th nzLeft nzWidth="150px">{{ 'users.column.lastName' | translate }}</th>
          <th nzWidth="170px">
            {{ 'users.column.identificationNo' | translate }}
          </th>
          <th nzWidth="150px">{{ 'users.column.gender' | translate }}</th>
          <th nzWidth="200px">
            {{ 'users.column.dateOfBirth' | translate }}
          </th>
          <th nzWidth="200px">
            {{ 'users.column.phoneNumber' | translate }}
          </th>
          <th nzWidth="200px">
            {{ 'users.column.balance' | translate }}
          </th>
          <th nzWidth="200px">
            {{ 'users.column.minutes' | translate }}
          </th>
          <th nzWidth="200px">
            {{ 'users.column.cashback' | translate }}
          </th>
          <th nzWidth="150px">{{ 'users.column.branch' | translate }}</th>
          <th nzWidth="150px">{{ 'users.column.userSource' | translate }}</th>
          <th nzWidth="150px">{{ 'users.column.role' | translate }}</th>
          <th nzWidth="150px">{{ 'users.column.created' | translate }}</th>
          <th nzWidth="120px" nzRight></th>
        </tr>
        </thead>
        <tbody>
          @for (row of loadData; track row; let i = $index) {
            <tr>
              <td>{{ row?.cardNo }}</td>
              <td nzLeft>
                <nz-space>
                  @if (row.isVerified) {
                    <div *nzSpaceItem>
                      <svg
                        t="1735934545574" class="cursor-pointer" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="1461" width="20" height="20">
                        <path
                          d="M426.666667 725.333333 256 554.666667 316.16 494.506667 426.666667 604.586667 707.84 323.413333 768 384M512 42.666667 128 213.333333 128 469.333333C128 706.133333 291.84 927.573333 512 981.333333 732.16 927.573333 896 706.133333 896 469.333333L896 213.333333 512 42.666667Z"
                          [attr.fill]="'green'"
                          p-id="1462"></path>
                      </svg>
                    </div>
                  }
                  <div *nzSpaceItem>{{ row?.firstname }}</div>
                </nz-space>
              </td>
              <td nzLeft>{{ row?.lastname }}</td>
              <td>{{ row?.identityNumber }}</td>
              <td>{{ row.gender | gender }}</td>
              <td>{{ row?.birthDate | date: 'dd/MM/yyyy' }}</td>
              <td>{{ row?.mobilePhone }}</td>
              <td>{{ row?.balance | number: '1.0-2' }}</td>
              <td>{{ row?.minutes }}</td>
              <td>{{ row?.cashback }}</td>
              <td>{{ row?.branch?.name }}</td>
              <td>{{ row?.userSource?.name }}</td>
              <td>
                <nz-tag>{{ 'USER_ROLE.' + row?.role | translate }}</nz-tag>
              </td>
              <td>{{ row?.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td nzRight>
                <nz-space nzSize="small">
                  <button
                    *nzSpaceItem
                    (click)="view(row)"
                    nz-button
                    nzType="primary"
                    nzSize="small"
                    nzShape="circle"
                  >
                    <i nz-icon nzType="eye"></i>
                  </button>
                  <ng-template [ngxPermissionsOnly]="['Admin', 'Manager']">
                    <button
                      *nzSpaceItem
                      (click)="addOrEdit(row)"
                      nz-button
                      nzType="default"
                      nzSize="small"
                      nzShape="circle"
                    >
                      <i nz-icon nzType="edit"></i>
                    </button>
                  </ng-template>
                  <ng-template [ngxPermissionsOnly]="['Admin', 'Manager']">
                    <button
                      *nzSpaceItem
                      nz-popconfirm
                      nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
                      nzPopconfirmPlacement="bottom"
                      (nzOnConfirm)="delete(row)"
                      nz-button
                      nzType="primary"
                      nzDanger
                      nzSize="small"
                      nzShape="circle"
                    >
                      <i nz-icon nzType="delete"></i>
                    </button>
                  </ng-template>
                </nz-space>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
